import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { PendingSurveyVM } from "@shared-kernel/application/ports/student/student-repository";

export const studentRetrievePendingSurveys = createAsyncThunk<PendingSurveyVM[], void, { extra: Partial<Dependencies> }>(
  "student/studentRetrievePendingSurveys",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.getPendingSurveys();
  },
);
